import { apiClient } from './apiClient';

const createContactEmail = async (data) => {
  return await apiClient.post_form(`/contact`, data);
};

const getLanguage = async (data) => {
  return await apiClient.get(`/api/language`, data);
};

const getCalculate = async (id, data) => {
  return await apiClient.get(`/api/calculate/${id}`, data);
};

const setLanguage = async (data) => {
  return await apiClient.get(`/language`, data);
};

export const appApi = {
  createContactEmail,
  getLanguage,
  getCalculate,
  setLanguage,
};
